(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (!form) return;

    // Function to update cart via AJAX
    function updateCartQuantity(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        // Reload the page to show updated cart
        window.location.reload();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        // Fallback to form submission
        form.submit();
      });
    }

    // Quantity increase/decrease buttons
    const quantityButtons = document.querySelectorAll('.quantity-selector__button');
    quantityButtons.forEach(button => {
      button.addEventListener('click', function() {
        const action = this.getAttribute('data-action');
        const line = parseInt(this.getAttribute('data-line'));
        const input = document.querySelector(`input[data-line="${line}"]`);
        
        if (!input) return;
        
        let currentValue = parseInt(input.value) || 0;
        let newValue = currentValue;
        
        if (action === 'increase') {
          newValue = currentValue + 1;
        } else if (action === 'decrease' && currentValue > 1) {
          newValue = currentValue - 1;
        } else if (action === 'decrease' && currentValue === 1) {
          newValue = 0;
        }
        
        // Update cart via AJAX
        updateCartQuantity(line, newValue);
      });
    });

    // Direct input change
    const quantityInputs = document.querySelectorAll('.quantity-selector__input');
    quantityInputs.forEach(input => {
      let timeout;
      input.addEventListener('change', function() {
        clearTimeout(timeout);
        const line = parseInt(this.getAttribute('data-line'));
        const newValue = parseInt(this.value) || 0;
        
        timeout = setTimeout(() => {
          updateCartQuantity(line, newValue);
        }, 500);
      });
    });

    // Countdown timer
    const timerElement = document.querySelector('.timer-countdown');
    if (timerElement) {
      let timeLeft = 15 * 60; // 15 minutes in seconds
      
      function updateTimer() {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        timerElement.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        
        if (timeLeft > 0) {
          timeLeft--;
        } else {
          clearInterval(timerInterval);
          timerElement.textContent = '0:00';
        }
      }
      
      updateTimer();
      const timerInterval = setInterval(updateTimer, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const filterToggle = document.getElementById('mobileFilterToggle');
    const filterOverlay = document.getElementById('mobileFilterOverlay');
    const filterClose = document.getElementById('mobileFilterClose');

    function closeMobileFilter() {
      if (filterOverlay) {
        filterOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }

    if (filterToggle && filterOverlay) {
      filterToggle.addEventListener('click', function() {
        filterOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (filterClose) {
        filterClose.addEventListener('click', closeMobileFilter);
      }

      // Also handle close button from the snippet
      const snippetCloseBtn = filterOverlay.querySelector('.filter-sidebar__close-btn');
      if (snippetCloseBtn) {
        snippetCloseBtn.addEventListener('click', closeMobileFilter);
      }

      // Click outside to close
      filterOverlay.addEventListener('click', function(e) {
        if (e.target === filterOverlay) {
          closeMobileFilter();
        }
      });

      // Escape key to close
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && filterOverlay.classList.contains('is-open')) {
          closeMobileFilter();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  const accordions = document.querySelectorAll('[data-accordion-type]');
  
  accordions.forEach(accordion => {
    const items = accordion.querySelectorAll('[data-accordion-item]');
    const type = accordion.dataset.accordionType || 'single';
    
    items.forEach(item => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      
      if (!trigger) return;
      
      trigger.addEventListener('click', () => {
        const isOpen = item.dataset.state === 'open';
        
        // If single mode, close all other items
        if (type === 'single' && !isOpen) {
          items.forEach(otherItem => {
            if (otherItem !== item) {
              closeAccordionItem(otherItem);
            }
          });
        }
        
        // Toggle current item
        if (isOpen) {
          closeAccordionItem(item);
        } else {
          openAccordionItem(item);
        }
      });
    });
  });
  
  function openAccordionItem(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    
    if (!trigger || !content) return;
    
    item.dataset.state = 'open';
    trigger.setAttribute('aria-expanded', 'true');
    
    // Trigger reflow for animation
    content.style.display = 'block';
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }
  
  function closeAccordionItem(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    
    if (!trigger || !content) return;
    
    item.dataset.state = 'closed';
    trigger.setAttribute('aria-expanded', 'false');
    content.style.maxHeight = '0';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  'use strict';
  
  // Mobile Menu
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileMenu = document.querySelector('.header__mobile-menu');
  const mobileClose = document.querySelector('.header__mobile-close');
  const mobileOverlay = document.querySelector('.header__mobile-overlay');

  if (mobileToggle && mobileMenu) {
    function openMobileMenu() {
      mobileMenu.setAttribute('aria-hidden', 'false');
      mobileToggle.setAttribute('aria-expanded', 'true');
    }

    function closeMobileMenu() {
      mobileMenu.setAttribute('aria-hidden', 'true');
      mobileToggle.setAttribute('aria-expanded', 'false');
    }

    mobileToggle.addEventListener('click', openMobileMenu);
    
    if (mobileClose) {
      mobileClose.addEventListener('click', closeMobileMenu);
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', closeMobileMenu);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
        closeMobileMenu();
      }
    });
  }

  // Collections Dropdown
  const dropdown = document.querySelector('.header__dropdown');
  const dropdownTrigger = document.querySelector('.header__dropdown-trigger');
  const dropdownMenu = document.querySelector('.header__dropdown-menu');

  if (dropdown && dropdownTrigger) {
    dropdownTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = dropdown.getAttribute('data-open') === 'true';
      dropdown.setAttribute('data-open', !isOpen);
      dropdownTrigger.setAttribute('aria-expanded', !isOpen);
    });

    document.addEventListener('click', function() {
      dropdown.setAttribute('data-open', 'false');
      dropdownTrigger.setAttribute('aria-expanded', 'false');
    });

    if (dropdownMenu) {
      dropdownMenu.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  }

  // Cart Drawer
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerToggles = document.querySelectorAll('[data-cart-drawer-toggle]');
  const cartDrawerClose = document.querySelector('.cart-drawer__close');
  const cartDrawerOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.setAttribute('aria-hidden', 'false');
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
  }

  cartDrawerToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const isOpen = cartDrawer.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        closeCartDrawer();
      } else {
        openCartDrawer();
      }
    });
  });

  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
      closeCartDrawer();
    }
  });

  // Cart Update Functions
  function updateCartCount(count) {
    const badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function(badge) {
      badge.textContent = count;
      if (count > 0) {
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  function updateCartDrawer() {
    fetch('/?section_id=header')
      .then(function(response) { return response.text(); })
      .then(function(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('.cart-drawer');
        const currentDrawer = document.querySelector('.cart-drawer');
        
        if (newDrawer && currentDrawer) {
          const isOpen = currentDrawer.getAttribute('aria-hidden') === 'false';
          currentDrawer.innerHTML = newDrawer.innerHTML;
          if (isOpen) {
            currentDrawer.setAttribute('aria-hidden', 'false');
          }
          attachCartEventListeners();
        }
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
      });
  }

  function changeQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      updateCartDrawer();
    })
    .catch(function(error) {
      console.error('Error changing quantity:', error);
    });
  }

  function attachCartEventListeners() {
    // Quantity increase
    document.querySelectorAll('[data-cart-increase]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const line = parseInt(this.getAttribute('data-cart-increase'));
        const item = this.closest('[data-cart-item]');
        const currentQty = parseInt(item.querySelector('.cart-drawer__quantity-value').textContent);
        changeQuantity(line, currentQty + 1);
      });
    });

    // Quantity decrease
    document.querySelectorAll('[data-cart-decrease]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const line = parseInt(this.getAttribute('data-cart-decrease'));
        const item = this.closest('[data-cart-item]');
        const currentQty = parseInt(item.querySelector('.cart-drawer__quantity-value').textContent);
        if (currentQty > 1) {
          changeQuantity(line, currentQty - 1);
        }
      });
    });

    // Remove item
    document.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const line = parseInt(this.getAttribute('data-cart-remove'));
        changeQuantity(line, 0);
      });
    });
  }

  // Initial cart event listeners
  attachCartEventListeners();

  // Listen for cart updates from other parts of the page
  document.addEventListener('cart:updated', function() {
    updateCartDrawer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
(function() {
  'use strict';
  
  function initGallery() {
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const imageWrappers = document.querySelectorAll('.product-gallery__image-wrapper');
    
    if (thumbs.length === 0 || imageWrappers.length === 0) {
      return;
    }
    
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const selectedIndex = this.getAttribute('data-image-index');
        
        // Remove active from all thumbs
        thumbs.forEach(function(t) {
          t.classList.remove('product-gallery__thumb--active');
        });
        
        // Add active to clicked thumb
        this.classList.add('product-gallery__thumb--active');
        
        // Remove active from all image wrappers
        imageWrappers.forEach(function(wrapper) {
          wrapper.classList.remove('product-gallery__image-wrapper--active');
        });
        
        // Add active to selected image wrapper
        imageWrappers.forEach(function(wrapper) {
          if (wrapper.getAttribute('data-image-index') === selectedIndex) {
            wrapper.classList.add('product-gallery__image-wrapper--active');
          }
        });
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
  
  // Tabs functionality
  function initTabs() {
    const tabButtons = document.querySelectorAll('.product-tabs__button');
    const tabContents = document.querySelectorAll('.product-tabs__content');
    const tabsWrapper = document.querySelector('.product-tabs__wrapper');
    
    if (tabButtons.length === 0) return;
    
    // Calculate the tallest tab content
    function setMaxTabHeight() {
      if (!tabsWrapper) return;
      
      let maxHeight = 0;
      
      // Temporarily show all tabs to measure their heights
      tabContents.forEach(function(content) {
        content.style.position = 'relative';
        content.style.visibility = 'hidden';
        content.style.display = 'block';
        
        const contentHeight = content.offsetHeight;
        if (contentHeight > maxHeight) {
          maxHeight = contentHeight;
        }
        
        // Reset styles
        content.style.position = '';
        content.style.visibility = '';
        content.style.display = '';
      });
      
      // Set the wrapper to the max height
      tabsWrapper.style.minHeight = maxHeight + 'px';
    }
    
    // Set initial max height
    setMaxTabHeight();
    
    // Recalculate on window resize
    window.addEventListener('resize', setMaxTabHeight);
    
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const tabName = this.dataset.tab;
        
        // Update buttons
        tabButtons.forEach(function(btn) {
          btn.classList.remove('product-tabs__button--active');
        });
        this.classList.add('product-tabs__button--active');
        
        // Update contents
        tabContents.forEach(function(content) {
          content.classList.remove('product-tabs__content--active');
          if (content.dataset.tabContent === tabName) {
            content.classList.add('product-tabs__content--active');
          }
        });
      });
    });
  }
  
  // Initialize tabs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
  
  // Quantity selector
  function initQuantity() {
    const quantityButtons = document.querySelectorAll('[data-quantity-change]');
    
    quantityButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const change = parseInt(this.dataset.quantityChange);
        const input = this.parentElement.querySelector('.product-quantity__input');
        const currentValue = parseInt(input.value);
        const min = parseInt(input.min);
        const max = parseInt(input.max);
        
        let newValue = currentValue + change;
        newValue = Math.max(min, Math.min(max, newValue));
        input.value = newValue;
      });
    });
  }
  
  // Initialize quantity
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantity);
  } else {
    initQuantity();
  }
  
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms-of-service"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  const accordions = document.querySelectorAll('[data-accordion-type]');
  
  accordions.forEach(accordion => {
    const items = accordion.querySelectorAll('[data-accordion-item]');
    const type = accordion.dataset.accordionType || 'single';
    
    items.forEach(item => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      
      if (!trigger) return;
      
      trigger.addEventListener('click', () => {
        const isOpen = item.dataset.state === 'open';
        
        // If single mode, close all other items
        if (type === 'single' && !isOpen) {
          items.forEach(otherItem => {
            if (otherItem !== item) {
              closeAccordionItem(otherItem);
            }
          });
        }
        
        // Toggle current item
        if (isOpen) {
          closeAccordionItem(item);
        } else {
          openAccordionItem(item);
        }
      });
    });
  });
  
  function openAccordionItem(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    
    if (!trigger || !content) return;
    
    item.dataset.state = 'open';
    trigger.setAttribute('aria-expanded', 'true');
    
    // Trigger reflow for animation
    content.style.display = 'block';
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }
  
  function closeAccordionItem(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    
    if (!trigger || !content) return;
    
    item.dataset.state = 'closed';
    trigger.setAttribute('aria-expanded', 'false');
    content.style.maxHeight = '0';
  }
})();

  } catch(e) { console.error(e); }
})();
})();
